import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M1.5 0h21S24 0 24 1.5v21s0 1.5-1.5 1.5h-21S0 24 0 22.5v-21S0 0 1.5 0"
    }, null, -1)
  ]));
}
const basicShapePrimarySquareRectangle = { render };
export {
  basicShapePrimarySquareRectangle as default,
  render
};
//# sourceMappingURL=basic-shape-primary-square-rectangle.svg.js.map
